import { JourneyDataModel } from '../../../../services/redux/features/journeyData.slice';
import { BusinessProspectFormModel } from './formModel';

export const requestMapper = (values: BusinessProspectFormModel): Partial<JourneyDataModel> => {
  return {
    businessCustomerType: values.businessCustomerType,
  };
};
